import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { useQuery } from '../../utils';
import { confirmBookingAction } from '../../actions/confirmBookingAction';
import { AppLogo } from '../../constants/AppLogo';
import Error from '../error/Error';
import { regexObjectId } from '../../constants/formats';

const ConfirmBooking = ({ confirmBooking, bookingConfirmation }) => {
  const { pending, success, error } = bookingConfirmation;
  const { bookingId } = useParams();

  const query = useQuery();
  const restId = query.get('restaurantId');
  const [idError, setIdError] = useState('');

  useEffect(() => {
    if (!bookingId) {
      return;
    }

    if (!regexObjectId.test(bookingId)) {
      setIdError('Invalid offer ID');
      return;
    }

    confirmBooking(bookingId, restId);
  }, []);

  const renderContent = () => {
    if (error) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <Typography>
            An error occurred while trying to confirm the offer. Please contact EatClub support.
          </Typography>
        </Box>
      );
    }

    if (idError) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <Typography variant='h6'>{idError}</Typography>
        </Box>
      );
    }

    if (pending) {
      return (
        <Box display='flex' alignItems='center' justifyContent='center'>
          <CircularProgress color='primary' size={22} style={{ marginRight: '1rem' }} />
          <Typography variant='h6'>Confirming offer</Typography>
        </Box>
      );
    }

    if (success) {
      return (
        <Box style={{ textAlign: 'center' }}>
          <Box style={{ marginBottom: '1rem' }}>
            <Typography variant='h6'>Complete</Typography>
            <Typography>The offer has been confirmed</Typography>
          </Box>

          <Button component={Link} to='/transactions' color='primary' variant='contained'>
            View in Partner Portal
          </Button>
        </Box>
      );
    }

    return null;
  };

  return (
    <Container maxWidth='sm'>
      <Box justifyContent='center' style={{ padding: '3rem 0 2rem', textAlign: 'center' }}>
        <Box height='35px'>
          <AppLogo style={{ height: 35 }} />
        </Box>
      </Box>

      <Card>
        <CardContent>
          {Boolean(error) && <Error error={!!error} message={error} />}
          {renderContent()}
        </CardContent>
      </Card>
    </Container>
  );
};

ConfirmBooking.propTypes = {
  confirmBooking: PropTypes.func.isRequired,
  bookingConfirmation: PropTypes.shape({
    // data: PropTypes.arrayOf(),
    pending: PropTypes.bool,
    error: PropTypes.string,
    success: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = (state) => ({ bookingConfirmation: state.confirmBooking });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ confirmBooking: confirmBookingAction }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmBooking);
